import { ReactNode } from 'react';

import { StyledGridItem } from './Grid.styled';

type Props = {
  children?: ReactNode;
  columnStart?: Array<number>;
  columnEnd?: Array<number>;
  justifySelf?: string;
  alignSelf?: string;
  order?: number;
  width?: string;
};

export function GridItem({
  columnStart,
  columnEnd,
  justifySelf,
  alignSelf,
  order,
  width,
  children,
}: Props) {
  return (
    <StyledGridItem
      columnStart={columnStart}
      columnEnd={columnEnd}
      justifySelf={justifySelf}
      alignSelf={alignSelf}
      order={order}
      width={width}
    >
      {children}
    </StyledGridItem>
  );
}
